// Enum labels for Phase 3 (City Operations) — the values are the EXACT
// strings the backend's ENUM columns accept (modules/tsp/constants/
// tspOperations.js in the brihadmrdanga-backend repo); only the display
// label is a frontend concern.

export const DISTRIBUTION_METHODS = [
  { value: "DOOR_TO_DOOR", label: "Door to Door" },
  { value: "SHOPS", label: "Shops" },
  { value: "SCHOOLS", label: "Schools" },
  { value: "COLLEGES", label: "Colleges" },
  { value: "UNIVERSITIES", label: "Universities" },
  { value: "GOVERNMENT_OFFICES", label: "Government Offices" },
  { value: "PUBLIC_PLACES", label: "Public Places" },
  { value: "EVENTS", label: "Events" },
  { value: "OTHERS", label: "Others" },
];

export const DISTRIBUTION_METHOD_LABEL = Object.fromEntries(DISTRIBUTION_METHODS.map((m) => [m.value, m.label]));

// Approved swatches from the Dashboard / Your Stats designs. SCHOOLS and
// COLLEGES were one merged "Schools/Colleges" bucket in the design; the
// backend's ENUM keeps them separate, so they share that bucket's hue family
// (two adjacent steps) rather than each getting an unrelated color.
export const DISTRIBUTION_METHOD_COLOR = {
  DOOR_TO_DOOR: "#F3B01B",
  SHOPS: "#3D9BD0",
  SCHOOLS: "#6C4FD6",
  COLLEGES: "#8B6DE0",
  UNIVERSITIES: "#9F1D21",
  GOVERNMENT_OFFICES: "#C588AC",
  PUBLIC_PLACES: "#2FA96A",
  EVENTS: "#5B6ACF",
  OTHERS: "#D96C6C",
};

export const RESPONSE_RATINGS = [
  { value: "EXCELLENT", label: "Excellent", color: "#2FA96A" },
  { value: "VERY_GOOD", label: "Very Good", color: "#3D9BD0" },
  { value: "GOOD", label: "Good", color: "#F3B01B" },
  { value: "POOR", label: "Poor", color: "#9F1D21" },
];

export const RESPONSE_RATING_LABEL = Object.fromEntries(RESPONSE_RATINGS.map((r) => [r.value, r.label]));
export const RESPONSE_RATING_TONE = { EXCELLENT: "green", VERY_GOOD: "blue", GOOD: "amber", POOR: "danger" };
